<template>
  <div class="creation-list">
    <!-- 顶部搜索区域 -->
    <div class="search-section">
      <div class="search-container">
        <el-input 
          v-model="document.title" 
          placeholder="请输入标题" 
          class="search-input"
        >
          <el-button 
            slot="append" 
            icon="el-icon-search" 
            @click="getlist"
          >搜索</el-button>
        </el-input>
        
        <router-link to="/home/creation/add">
          <el-button type="primary" class="create-btn" v-real-name-auth="'创建作品'">
            <svg class="create-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- 发光背景 -->
              <circle cx="12" cy="12" r="12" fill="rgba(255,255,255,0.15)" class="glow"/>
              
              <!-- 笔和纸张图标 -->
              <g class="pen-paper">
                <!-- 纸张背景 -->
                <path 
                  d="M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3Z" 
                  stroke="white" 
                  stroke-width="2" 
                  stroke-linecap="round"
                  fill="rgba(255,255,255,0.2)"
                  class="paper"
                />
                
                <!-- 笔尖 -->
                <path 
                  d="M14 7L17 10M8 16H9L16 9L13 6L6 13V14L8 16Z" 
                  stroke="white" 
                  stroke-width="2.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                  class="pen"
                />
                
                <!-- 装饰线条 -->
                <path 
                  d="M8 8H6M8 12H6" 
                  stroke="white" 
                  stroke-width="2" 
                  stroke-linecap="round"
                  class="lines"
                />
              </g>
            </svg>
            <span class="btn-text">创作</span>
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- 内容列表区域 -->
    <div class="content-container">
      <el-row :gutter="20">
        <el-col 
          :md="8" 
          v-for="(item, index) in list" 
          :key="index"
        >
          <div class="content-card">
            <!-- 封面图 -->
            <div class="cover-wrapper">
              <img
                :src="item.cover"
                :alt="item.title"
                class="cover-image"
              />
              <div class="price-tag">
                <el-tag type="danger">¥ {{item.amt}}</el-tag>
              </div>
            </div>

            <!-- 内容信息 -->
            <div class="content-info">
              <h3 class="title">{{item.title}}</h3>
              <div class="meta-info">
                <time class="time">{{ item.createTime }}</time>
              </div>

              <!-- 操作按钮组 -->
              <div class="action-buttons">
                <el-button 
                  type="primary" 
                  size="small" 
                  icon="el-icon-edit" 
                  @click="edit(item.id)"
                >编辑</el-button>

                <el-button
                  v-if="item.status==1"
                  size="small"
                  type="info"
                  icon="el-icon-bottom"
                  @click="update(item.id,0)"
                >下架</el-button>

                <el-button
                  v-if="item.status==0"
                  size="small"
                  type="success"
                  icon="el-icon-top"
                  @click="update(item.id,1)"
                >上架</el-button>
                <el-button
                    v-if="item.status==3"
                    size="small"
                    type="danger"
                >违规</el-button>
                <el-button
                  v-if="item.status==1"
                  size="small"
                  type="success"
                  @click="viewLink(item.id)"
                >查看</el-button>

                <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="del(item.id)"
                >删除</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 空状态 -->
      <el-empty 
        v-if="list.length==0" 
        description="你还没有发布任何作品"
      ></el-empty>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :page-size="12"
          :current-page="document.pageNum"
          @current-change="currentChange"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total:0,
      document:{
        title:'',
        pageNum:1,
        pageSize:12
      },
      list:[]
    };
  },
  mounted(){
    this.getlist();
  },
  methods: {
    viewLink(id){
      this.$router.push({ path:"/home/creation/linkSetting",query:{id}});
      // this.$alert('https://zs.klgeek.com/#/creation?id='+id, '链接', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //     if(action=="cancel") return;
      //     navigator.clipboard.writeText('https://zs.klgeek.com/#/creation?id='+id)
      //         .then(() => {
      //           this.$message({
      //             type: 'info',
      //             message: `复制成功`
      //           });
      //         })
      //         .catch(err => {
      //           console.error('复制失败: ', err);
      //         });
      //
      //   }
      // });

    },
    update(id,status){

      this.$http2({
        url: `/klgeek/creation/update`,
        method: 'put',
        data:{id,status}
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '更新成功!'
        });
        this.getlist()
      })
    },
    currentChange(num) {
      this.document.pageNum=num
      this.getlist()
    },
    edit(id){
      this.$router.push({ path: '/home/creation/edit', query: { id: id } });
    },
    del(id){
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http2({
          url: `/klgeek/creation/${id}`,
          method: 'delete'
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    getlist(){
      this.$http2({
        url: `/klgeek/creation/list?pageNum=${this.document.pageNum}&pageSize=${this.document.pageSize}&title=${this.document.title}`,
        method: 'get'
      }).then((res) => {
        this.list=res.rows
        this.total=res.total
      })
    },
    add(){

    }
  },
}
</script>

<style scoped lang="scss">
.creation-list {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  width: 100%;
  .search-section {
    margin-bottom: 24px;

    .search-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      gap: 16px;

      .search-input {
        width: 400px;
      }

      .create-btn {
        margin-left: auto;
      }
    }
  }

  .content-container {
    max-width: 1200px;
    margin: 0 auto;

    .content-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      transition: transform 0.3s, box-shadow 0.3s;
      margin-bottom: 20px;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      }

      .cover-wrapper {
        position: relative;
        height: 200px;
        overflow: hidden;

        .cover-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.05);
          }
        }

        .price-tag {
          position: absolute;
          top: 12px;
          right: 12px;
        }
      }

      .content-info {
        padding: 16px;

        .title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .meta-info {
          color: #999;
          font-size: 13px;
          margin-bottom: 12px;
        }

        .action-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
      }
    }
  }

  .pagination-wrapper {
    margin-top: 32px;
    display: flex;
    justify-content: center;
  }
}

.create-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #FF6B6B 0%, #FF4757 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  height: auto;
}

.create-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #FF8787 0%, #FF6B6B 100%);
}

.create-btn:active {
  transform: translateY(0);
}

.create-icon {
  animation: float 3s ease-in-out infinite;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.btn-text {
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 16px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 图标动画效果 */
.glow {
  animation: pulse 2s ease-in-out infinite;
}

.pen {
  animation: write 3s ease-in-out infinite;
}

.lines {
  animation: fade 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes write {
  0%, 100% {
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dashoffset: 10;
  }
}

@keyframes fade {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .create-btn {
    padding: 8px 16px;
  }
  
  .create-icon {
    width: 20px;
    height: 20px;
  }
  
  .btn-text {
    font-size: 14px;
  }
}
</style>